import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Redirect, Route, withRouter } from 'react-router-dom';

class PrivateRoute extends React.PureComponent {
  render() {
    const { component: Component, location, user, ...otherProps } = this.props;
    return (
      <Route
        {...otherProps}
        render={innerProps => {
          if (user.isAuthenticated === true) {
            return <Component {...innerProps} />;
          } else {
            return (
              <Redirect
                to={{
                  pathname: '/login',
                  search: `?next=${location.pathname}`
                }}
              />
            );
          }
        }}
      />
    );
  }
}

PrivateRoute.propTypes = {
  component: PropTypes.object.isRequired,
  funnyUser: PropTypes.object.isRequired
};

export default withRouter(
  connect(
    state => ({
      user: state.buckaneer.user
    }),
    {}
  )(PrivateRoute)
);
